<template>
  <div>
    <template v-if="profileData">
      <v-card class="bg-profile-card pa-3" max-width="1000px">
        <v-layout wrap>
          <v-flex xs3 class="align-center" style="display: flex">
            <v-avatar :tile="false" size="128px" color="grey lighten-4">
              <img :src="profileData.profile_pic" alt="avatar" />
            </v-avatar>
          </v-flex>
          <v-flex xs9>
            <v-layout wrap>
              <v-flex xs12 pb-2 style="font-size: 28px; font-weight: 700">
                <div>{{ profileData.first_name }} {{ profileData.last_name }}</div>
              </v-flex>
              <v-flex xs6>
                <v-layout wrap>
                  <v-flex xs6 py-1 class="font-weight-bold">อายุ</v-flex>
                  <v-flex xs6 py-1>{{ profileData.age }} ปี</v-flex>
                  <v-flex xs6 py-1 class="font-weight-bold">เพศ</v-flex>
                  <v-flex xs6 py-1>{{ handleGetGenderLabel(profileData.gender) }}</v-flex>
                  <v-flex xs6 py-1 class="font-weight-bold">น้ำหนัก</v-flex>
                  <v-flex xs6 py-1>{{ profileData.weight }} กิโลกรัม</v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs6>
                <v-layout wrap>
                  <v-flex xs6 py-1 class="font-weight-bold">วุฒิการศึกษา</v-flex>
                  <v-flex xs6 py-1>{{ profileData.graduation }}</v-flex>
                  <v-flex xs6 py-1 class="font-weight-bold">สถานะการทำงาน</v-flex>
                  <v-flex xs6 py-1>{{ profileData.work_status }}</v-flex>
                  <v-flex xs6 py-1 class="font-weight-bold">รายได้เฉลี่ยต่อเดือน</v-flex>
                  <v-flex xs6 py-1>{{ profileData.income }}</v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </template>
  </div>
</template>

<script>
import nongtungjaiApi from '@/api/nongtungjai'
import { mapGetters } from 'vuex'
export default {
  props: ['memberId'],
  data() {
    return {
      profileData: []
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  async mounted() {
    await this.handleGetProfile()
  },
  methods: {
    async handleGetProfile() {
      const vm = this
      try {
        const response = await vm.getPatientList()
        if (response) {
          vm.profileData = response.data[0]
        }
      } catch (error) {
        console.error(error)
      }
    },
    async getPatientList() {
      const vm = this
      let data = {
        page_id: vm.selectedBot.pageid,
        limit: 1,
        offset: 0,
        member_id: vm.memberId
      }

      vm.loading = true
      const response = await nongtungjaiApi.getPatientList({
        config: {
          params: data
        }
      })

      vm.loading = false
      if (response && response.status === 200) {
        return response.data
      } else {
        return null
      }
    },
    handleGetGenderLabel(value) {
      return value === 'male' ? 'ชาย' : 'หญิง'
    }
  }
}
</script>

<style lang="scss" scoped>
.bg-profile-card {
  background: linear-gradient(180deg, rgba(0, 147, 233, 0.8) 0%, #80d0c7 100%);
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/NongTungJai/ProfileCard.vue